import React from 'react'
import Aux from 'react-aux'
import {NavLink} from "react-router-dom";
import logo from '../../../../public/images/logo_white.png'

export const NavbarComponent = () => {
    return (
        <Aux>
            <nav className="navbar-default navbar-static-side" role="navigation">
                <div className="sidebar-collapse">
                    <ul className="nav metismenu skin-1" id="side-menu">
                        <NavLink to="/" className={"nav-link p-0"} exact activeClassName={"active"}>
                            <li className="nav-header">
                                <img src={logo} className={'img-fluid'} alt={''}/>
                            </li>
                        </NavLink>
                        <li>
                            <NavLink to="/" className={"nav-link"} exact activeClassName={"active"}>
                                <span className={'nav-label'}>Home</span>
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/countries" className={"nav-link"} exact activeClassName={"active"}>
                                <span className={'nav-label'}>Countries</span>
                            </NavLink>
                        </li>
                        <li className={"nav-item"}>
                            <NavLink to="/drugs" className={"nav-link"} exact
                                     activeClassName={"active"}>Drugs</NavLink>
                        </li>
                        <li className={"nav-item"}>
                            <NavLink to="/statistics" className={"nav-link"} exact
                                     activeClassName={"active"}>ATC Statistics</NavLink>
                        </li>
                        <li className={"nav-item"}>
                            <NavLink to="/companies" className={"nav-link"} exact
                                     activeClassName={"active"}>Companies</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </Aux>
    )
}
